import request from "@/request/confJs/request";
import { API_ENDPOINTS } from "@/config/api";
import { toStoredFileValue } from "@/utils/fileUrl";

const article = API_ENDPOINTS.article;
const withStoredThumbnail = (data) => ({
  ...data,
  thumbnail: toStoredFileValue(data?.thumbnail),
});

export const getArticleList = (data) => request({ url: article.list, method: "POST", data });
export const publishArticle = (data) => request({ url: article.publish, method: "POST", data: withStoredThumbnail(data) });
export const saveAsDraft = (data) => request({ url: article.saveDraft, method: "POST", data: withStoredThumbnail(data) });
export const getHotArticleList = () => request({ url: article.hotList, method: "GET" });
export const getArticleById = (id) => request({ url: article.detail, method: "GET", params: { id } });
export const searchByTitleOrContent = (data) => request({ url: article.search, method: "POST", data });
export const getArticleListByUserId = () => request({ url: article.userArticles, method: "GET" });
export const updateArticleById = (data) => request({ url: article.update, method: "POST", data: withStoredThumbnail(data) });
export const getArticleDetailById = (id) => request({ url: article.editDetail, method: "GET", params: { id } });
export const delArticleById = (id) => request({ url: article.remove, method: "POST", params: { id } });
export const getUserLikedArticles = () => request({ url: article.liked, method: "POST" });
export const likeOrCollect = (data) => request({ url: article.interaction, method: "POST", data: { articleId: data?.articleId, action: data?.action } });
export const getArticleInteractionState = (articleId) => request({ url: article.interactionState, method: "GET", params: { articleId } });
export const getUserCollected = () => request({ url: article.collected, method: "POST" });
export const getMyFavoritesByUserId = () => request({ url: article.favorites, method: "GET" });
export const getMyDraftsByUserId = () => request({ url: article.drafts, method: "GET" });
